import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { INCPCCPayment, CreditCardService, ErrorHandlerService, AuthService, CommonSettings, CREDITCARD_VENDOR } from 'epay-library';
import { Router } from '@angular/router';
import { EpayExtendedServiceService } from 'src/app/helpers/services/epay-extended-service.service';
import { ExternalIframeComponent } from './ncpcredit-card-fort-point/iframe-fort-point.component';

@Component({
  selector: 'ncp-creditcard-submit-common',
  templateUrl: './ncpcredit-card-submit-common.component.html',
  //styleUrls: ['./iframe-fort-point.component.css'],
})
export class NCPCreditCardSubmitCommonComponent implements OnInit {
  @Input() baseurl = '';
  @Input() secondaryIdAlias = '';
  @Input() creditCardVendorId = 0;
  @Input() creditCardDisclaimer = '';
  @Input() ccSecurityMessage = '';
  @Input() creditCardPayment: INCPCCPayment = {} as INCPCCPayment;
  @Input() createPaymentButtonText = 'Continue';
  @Input() showFees: boolean = false;
  @ViewChild(ExternalIframeComponent)
  iframeComponent!: ExternalIframeComponent;

  disableCreatePaymentButton: boolean = false;

  showIframe: boolean = false;
  iframeUrl: string = "https://sandbox-smi.fppdashboard.com";

  paymentheader: string[] = [];

  ncpUseCaseNumberForPayment: boolean;
  transactionId = '';
  errorMessage = '';
  totalCCPayment = 0;

  clientName = '';
  clientId = '';

  goToCivitek = false;
  goToFortPoint = false;
  creditCardUrl = '';
  fortPointStateCode = '';
  civitekOriginKey = '';
  stateName = '';

  constructor(
    private creditCardService: CreditCardService,
    private errorHandlerService: ErrorHandlerService,
    private authService: AuthService,
    public router: Router,
    private paymentService: EpayExtendedServiceService
  ) {
    this.transactionId = '';
    this.clientId = CommonSettings.ClientID;
    this.stateName = CommonSettings.StateName;
    this.ncpUseCaseNumberForPayment =
      CommonSettings.NCPUseCaseNumberForPayments;

    this.clientName = CommonSettings.ClientName;

    if (this.ccSecurityMessage === '') {
      this.ccSecurityMessage =
        `For security reasons, we do not collect credit card information.
      By clicking 'Continue' you are leaving the ` +
        this.stateName +
        ` SDU Internet Payment Web Site
      and will be taken to our credit card processor&rsquo;s web site to pay with your credit card.`;
    }

    if (this.createPaymentButtonText === '') {
      this.createPaymentButtonText = 'Continue';
    }
  }

  toggleIframe(): void {
    this.showIframe = !this.showIframe;
  }

  ngOnInit() {
  sessionStorage.removeItem('cameFromSuccessPage');

  this.totalCCPayment = this.totalCreditCardAmount;
  this.creditCardPayment.totalAmount = this.totalCCPayment;

    if (this.ncpUseCaseNumberForPayment) {
      this.paymentheader = [
        'First Name',
        'Last Name',
        'Date of Birth',
        'SSN',
        'Case Number',
        'Amount',
      ];

      if (this.secondaryIdAlias !== '') {
        this.paymentheader = [
          'First Name',
          'Last Name',
          'Date of Birth',
          'SSN',
          this.secondaryIdAlias,
          'Amount',
        ];
      }
    } else {
      this.paymentheader = ['First Name', 'Last Name', 'SSN', 'Amount'];
      this.secondaryIdAlias = 'Case Number';
    }
  }

  ngOnChanges() {
    if (+this.creditCardVendorId === CREDITCARD_VENDOR.CIVITEK) {
      this.creditCardUrl = CommonSettings.CivitekCreditCardUrl;
      this.civitekOriginKey = CommonSettings.CivitekOriginKey;
    }

    if (+this.creditCardVendorId === CREDITCARD_VENDOR.FORTPOINT) {
      this.creditCardUrl = CommonSettings.FortPointCreditCardUrl;
      this.fortPointStateCode = CommonSettings.FortPointStateCode;
    }
  }

  get serviceFeeAmount(): number {
    const amount = this.creditCardPayment.amount || 0;
    const feePercentage = this.creditCardPayment.feePercentage || 0;
    const fee = amount * feePercentage;
    return Math.round((fee + Number.EPSILON) * 100) / 100;
  }

  get totalCreditCardAmount(): number {
    const amount = this.creditCardPayment.amount || 0;
    return amount + this.serviceFeeAmount;
  }

  maskSSN(ssn: string | undefined): string {
  if (!ssn || ssn.length < 4) return '';
  return ssn.slice(-4);
  }

  createCCPayment() {
  this.disableCreatePaymentButton = true;
  this.createPaymentButtonText = 'Processing....';
  this.creditCardPayment.confirm = true;

  this.totalCCPayment = this.totalCreditCardAmount;
  this.creditCardPayment.totalAmount = this.totalCCPayment;
  }

  sendPaymentDataToApi(paymentData: any) {  
    const firstName3 = (this.creditCardPayment.firstName || '').substring(0, 3).toUpperCase();
    const lastName3 = (this.creditCardPayment.lastName || '').substring(0, 3).toUpperCase();
    const identifiers = [
      { key: "ssn", value: this.creditCardPayment.ssn || '' },
      { key: "remittanceid", value: this.creditCardPayment.primaryId || '' },
      { key: "firstname", value: firstName3 },
      { key: "lastname", value: lastName3 }
    ];
  
    const payor: any = {
      clientId: Number(CommonSettings.ClientID),
      amount: Number(this.creditCardPayment.amount),
      isConfirmed: true,
      paymentDetails: {
        cardType: '',
        last4OfCard: '',
        firstName: paymentData.firstName || '',
        lastName: paymentData.lastName || '',
        email: '',
        phone: '',
        billingAddress: {
          streetAddress: '',
          city: '',
          state: '',
          postalCode: ''
        }
      },
      identifiers: identifiers
    };
    
    const baseUrl = CommonSettings.BaseApi;
  
    this.paymentService.postPaymentProcess(baseUrl, payor).subscribe({
      next: (response: any) => {
        this.transactionId = response.transactionId;
  
        this.router.navigate(['/ncp/creditcard/iframe-fort-point'], {
          state: { transactionId: this.transactionId }
        });
      },
      error: (error: any) => console.error("API Call Failed:", error),
    });
  }
  
  navigateWithPayment() {
    sessionStorage.removeItem('iframeVisited');
    sessionStorage.setItem('creditCardPayment', JSON.stringify(this.creditCardPayment));
    this.sendPaymentDataToApi(this.creditCardPayment);
  }

  logError(error: Error) {
    this.errorHandlerService.logError(error);
  }

  handleError(error: number) {
    this.errorHandlerService.handleErrorMessage(error, this.baseurl);
  }
}
